import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
// import Button from '@mui/material/Button';
// import Paper from '@mui/material/Paper';
// import Typography from '@mui/material/Typography';
import SubCard from 'ui-component/cards/SubCard';
import { Typography } from '@mui/material';

// const userType='TM'

const steps = [
  {
    label: 'DS',
    name:'ds_id',
    key:'ds_permission',
    headingName:'DS Name',
    type:'DS'
  },
  {
    label: 'Tertiary Manager',
    name:'tm_id',
    key:'tm_permission',
    headingName:'TM Name',
    type:'TM'
  },

  {
    label: 'State Head',
    name:'sh_id',
    key:'sh_permission',
    headingName:'SH Name',
    type:'SH'
  },

  {
    label: 'Operations',
    name:'sh_id',
    key:'sh_permission',
    headingName:'Operations name',
    type:'OPS'
  },

];

export default function VerticalLinearStepper(props) {
   const [activeStep, setActiveStep] = React.useState(-1);

   console.log(setActiveStep);
//   const handleNext = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep + 1);
//   };

//   const handleBack = () => {
//     setActiveStep((prevActiveStep) => prevActiveStep - 1);
//   };

//   const handleReset = () => {
//     setActiveStep(0);
//   };
const [expandedSteps, setExpandedSteps] = React.useState(steps.map(() => true)); // Initialize all steps as expanded

console.log(setExpandedSteps);

  return (
    <Box sx={{ maxWidth: 400 }}>
      <Stepper activeStep={activeStep} orientation="vertical" >
        {steps.map((step, index) => (
          <Step key={index} expanded={expandedSteps[index]} completed={props.data?props.data[step.key]==='approved'?true:false:false}>
            <StepLabel>
              {step.label}
            </StepLabel>
            <StepContent>
              <SubCard sx={{width:'20rem'}}>
                <Typography variant='subtitle1'>{step.headingName}: {props.data?props.data[step.name]:''}</Typography>
                <Typography variant='h5' color='green' visibility={props.data?props.data[step.key]==='approved'?'visible':'hidden':'hidden'}>Approved</Typography>
                <Typography variant='h5' color='grey'  visibility={props.data?props.data[step.key]==='pending'?'visible':'hidden':'hidden'}>Pending</Typography>
                <Typography variant='h5' color='red'  visibility={props.data?props.data[step.key]==='rejected'?'visible':'hidden':'hidden'}>Rejected</Typography>
              </SubCard>
            </StepContent>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
}
